<template>
    <!-- 龙虎榜 -->
    <div
        class="dragonTigerWrap"
        @click.stop.prevent="handleClickGroupDetail"
    >
        <!-- TODO 模拟 -->
        <div class="dragonTigerTitle"></div>
        <div class="dragonTigerDetail">
            <div class="dragonTigerList">
                <h5 class="dragonTigerGuessTitle">{{msg.title}}</h5>
                <p class="dragonTigerGuessInfo">查看上榜机构 参与讨论</p>
            </div>
            <div class="dragonTigerGuessBtns">
                <div class="dragonTigerGuessBtn">查看详情</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "stockGroup",
    props: {
        msg: {
            type: Object,
            default: () => {
                return {}
            }
        },
        type: {
            type: String,
            default: "normal"
        }
    },
    data() {
        return {
            is_follow: "no",
            follow_num: 0,
            loading: false,
        }
    },
    created() {
        let msg = this.msg;
    },
    methods: {
        handleClickGroupDetail() {
            let msg = this.msg;
            this.openNative("dragon_tiger_detail", {
                stock_code: msg.stock_code,
                stock_name: msg.stock_name,
                trade_day: msg.trade_day
            })
        },
        // 跳转APP页面
        openNative(type, query = {}) {
            let params = {
                kind: type, // 类型
            };

            // 同步传参
            params = {
                ...params,
                ...query
            }

            switch (type) {
                case "dragon_tiger_detail": // 龙虎榜
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native', params)
        },
    }
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.dragonTigerWrap {
    margin: 10px 12px 0;
    height: auto;
    padding: 0px 8px 0 0;
    background: #F7F7F7;
    border-radius: 0;
    border: none;
    display: flex;
    box-sizing: border-box;

    .dragonTigerTitle {
        width: 68px;
        height: 68px;
        margin-right: 10px;
        position: relative;
        background-color: transparent;
        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/lhb_bsbb.svg");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 68px;
    }

    .dragonTigerDetail {
        height: 100%;
        display: flex;
        justify-content: space-between;
        flex: 1;
        overflow: hidden;
        padding-top: 10px;

        .dragonTigerList {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            overflow: hidden;

            .dragonTigerGuessTitle {
                color: $a-normal;
                font-size: 14px;
                line-height: 20px;
                padding-right: 10px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            .dragonTigerGuessInfo {
                font-size: 12px;
                line-height: 17px;
                color: #939393;
                margin-top: 11px;
            }
        }

        .dragonTigerGuessBtns {
            display: flex;
            flex-direction: column;
            height: 100%;
            justify-content: space-around;

            >div.dragonTigerGuessBtn {
                width: 60px;
                height: 24px;
                background: #FE484A;
                border-radius: 2px;
                color: #ffffff;
                text-align: center;
                font-size: 12px;
                line-height: 24px;
            }
        }
    }
}
</style>